import { SvgIcon, SvgIconProps } from '@mui/material';

const PlayCircleIcon = (props: SvgIconProps) => (
  <SvgIcon width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_19000_40091)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M16.4987 26.6654C22.3912 26.6654 27.1654 21.8912 27.1654 15.9987C27.1654 10.1062 22.3912 5.33203 16.4987 5.33203C10.6062 5.33203 5.83203 10.1062 5.83203 15.9987C5.83203 21.8912 10.6062 26.6654 16.4987 26.6654ZM7.20838 15.9988C7.20838 10.8935 11.3417 6.70852 16.4987 6.70852C21.6041 6.70852 25.789 10.8419 25.789 15.9988C25.789 21.1042 21.6557 25.2892 16.4987 25.2892C11.3933 25.2892 7.20838 21.1558 7.20838 15.9988ZM21.4751 15.2246L13.9052 10.6224C13.2256 10.2439 12.3697 10.73 12.3697 11.5257V20.4719C12.3697 21.2633 13.2213 21.7536 13.9052 21.3751L21.4751 17.031C22.1804 16.6397 22.1804 15.6203 21.4751 15.2246ZM13.746 19.4309V12.5965C13.746 12.3943 13.9654 12.2696 14.1374 12.3771L19.9223 15.8911C20.0901 15.9943 20.0858 16.2395 19.9181 16.3341L14.1331 19.6546C13.9611 19.7535 13.746 19.6287 13.746 19.4309L13.746 19.4309Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19000_40091">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default PlayCircleIcon;
